import { clientsApi } from '@modules/clients/entities/client/api';
import { toast } from '@huspy/forge/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useGetEmailPreferences = (accountExternalId: string) => {
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['getEmailPreferences'],
    queryFn: () => clientsApi.getEmailPreferences(accountExternalId),
    placeholderData: keepPreviousData,
    enabled: true,
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
    select: (emailPreferencesData) => ({
      isVerified: emailPreferencesData.emailPreferences.some(
        (item) => item.isVerified
      ),
      emailProvider: emailPreferencesData.emailPreferences.find(
        (item) => item.isPreferred
      )?.emailProvider!,
    }),
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useGetEmailPreferences;
